import React, { useState } from 'react';
import './Gallery.css';

import Colab2 from './videos/Colab (2).mp4';
import Colab from './videos/Colab.mp4';
import KYC2 from './videos/KYC (2).mp4';
import KYC3 from './videos/KYC (3).mp4';
import KYC4 from './videos/KYC (4).mp4';
import KYC5 from './videos/KYC (5).mp4'; // Adding KYC5
import KYC6 from './videos/KYC (6).mp4'; // Adding KYC6
import KYC7 from './videos/KYC (7).mp4'; // Adding KYC7
import KYC8 from './videos/KYC (8).mp4'; // Adding KYC8
import KYC from './videos/KYC.mp4';

import Alutha from './images/Alutha Tyalane.jpeg';
import Athandwe from './images/Athandwe Mngcongco.jpeg';
import Athimna from './images/Athimna Donkile.jpeg';
import AviweMdleleni from './images/Aviwe Mdleleni.jpeg';
import BelindaBobby from './images/Belinda Bobby.jpeg';
import Chulumanco from './images/Chulumanco Donkile.jpeg';
import Endinako from './images/Endinako Mngwabane.jpeg';
import Esona from './images/Esona Ngwevela.jpeg';
import Mbali from './images/Mbali George.jpeg';
import Karabo from './images/Karabo Mbenja.jpeg';
import Keoratile from './images/Keoratile.jpeg';
import LisakhanyaNunu from './images/Lisakhanya Nunu.jpeg';
import LiyemaNunu from './images/Liyema Nunu.jpeg';
import LwaziSolani from './images/Lwazi Solani.jpeg';
import Inga from './images/Inga.jpeg';
import Mpumelelo from './images/Zulu Mpumelelo.jpeg';
import NandiVokwana from './images/Nandi Vokwana.jpeg';
import Oyama from './images/Oyama Ngeju.jpeg';
import Qhamile from './images/Qhamile Mgogodlana.jpeg';
import SibuleleRwadi from './images/Sibulele Rwadi.jpeg';
import Thulani from './images/Thulani Mtshwelo.jpeg';
import Uvuyo from './images/Uvuyo Teba.jpeg';
import Vuyokazi from './images/Vuyokazi Gxowa.jpeg';
import YolethaJack from './images/Yoletha Jack.jpeg';
import Zethu from './images/zethu Tolbani.jpeg';
import Zizipho from './images/Zizipho Ntuli.jpeg';
import Zukhanye from './images/Zukhanye.jpeg';

// Adding back the WhatsApp images
import WhatsApp_Image_2025_04_25_at_14_40_45_1 from './images/WhatsApp Image 2025-04-25 at 14.40.45 (1).jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_45_2 from './images/WhatsApp Image 2025-04-25 at 14.40.45 (2).jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_45 from './images/WhatsApp Image 2025-04-25 at 14.40.45.jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_46_1 from './images/WhatsApp Image 2025-04-25 at 14.40.46 (1).jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_46 from './images/WhatsApp Image 2025-04-25 at 14.40.46.jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_47_1 from './images/WhatsApp Image 2025-04-25 at 14.40.47 (1).jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_47 from './images/WhatsApp Image 2025-04-25 at 14.40.47.jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_48 from './images/WhatsApp Image 2025-04-25 at 14.40.48.jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_49 from './images/WhatsApp Image 2025-04-25 at 14.40.49.jpeg';
import WhatsApp_Image_2025_04_25_at_14_40_50 from './images/WhatsApp Image 2025-04-25 at 14.40.50.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_08 from './images/WhatsApp Image 2025-04-25 at 14.42.08.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_18 from './images/WhatsApp Image 2025-04-25 at 14.42.18.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_29 from './images/WhatsApp Image 2025-04-25 at 14.42.29.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_30 from './images/WhatsApp Image 2025-04-25 at 14.42.30.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_31 from './images/WhatsApp Image 2025-04-25 at 14.42.31.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_34 from './images/WhatsApp Image 2025-04-25 at 14.42.34.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_35 from './images/WhatsApp Image 2025-04-25 at 14.42.35.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_36_1 from './images/WhatsApp Image 2025-04-25 at 14.42.36 (1).jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_36 from './images/WhatsApp Image 2025-04-25 at 14.42.36.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_37 from './images/WhatsApp Image 2025-04-25 at 14.42.37.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_38 from './images/WhatsApp Image 2025-04-25 at 14.42.38.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_39 from './images/WhatsApp Image 2025-04-25 at 14.42.39.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_40_1 from './images/WhatsApp Image 2025-04-25 at 14.42.40 (1).jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_40 from './images/WhatsApp Image 2025-04-25 at 14.42.40.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_41 from './images/WhatsApp Image 2025-04-25 at 14.42.41.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_42_1 from './images/WhatsApp Image 2025-04-25 at 14.42.42 (1).jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_42 from './images/WhatsApp Image 2025-04-25 at 14.42.42.jpeg';
import WhatsApp_Image_2025_04_25_at_14_42_43 from './images/WhatsApp Image 2025-04-25 at 14.42.43.jpeg';

const images = [
  Alutha,
  Athandwe,
  Athimna,
  AviweMdleleni,
  BelindaBobby,
  Chulumanco,
  Endinako,
  Esona,
  Mbali,
  Karabo,
  Keoratile,
  LisakhanyaNunu,
  LiyemaNunu,
  LwaziSolani,
  Inga,
  Mpumelelo,
  NandiVokwana,
  Oyama,
  Qhamile,
  SibuleleRwadi,
  Thulani,
  Uvuyo,
  Vuyokazi,
  YolethaJack,
  Zethu,
  Zizipho,
  Zukhanye,
  WhatsApp_Image_2025_04_25_at_14_40_45_1,
  WhatsApp_Image_2025_04_25_at_14_40_45_2,
  WhatsApp_Image_2025_04_25_at_14_40_45,
  WhatsApp_Image_2025_04_25_at_14_40_46_1,
  WhatsApp_Image_2025_04_25_at_14_40_46,
  WhatsApp_Image_2025_04_25_at_14_40_47_1,
  WhatsApp_Image_2025_04_25_at_14_40_47,
  WhatsApp_Image_2025_04_25_at_14_40_48,
  WhatsApp_Image_2025_04_25_at_14_40_49,
  WhatsApp_Image_2025_04_25_at_14_40_50,
  WhatsApp_Image_2025_04_25_at_14_42_08,
  WhatsApp_Image_2025_04_25_at_14_42_18,
  WhatsApp_Image_2025_04_25_at_14_42_29,
  WhatsApp_Image_2025_04_25_at_14_42_30,
  WhatsApp_Image_2025_04_25_at_14_42_31,
  WhatsApp_Image_2025_04_25_at_14_42_34,
  WhatsApp_Image_2025_04_25_at_14_42_35,
  WhatsApp_Image_2025_04_25_at_14_42_36_1,
  WhatsApp_Image_2025_04_25_at_14_42_36,
  WhatsApp_Image_2025_04_25_at_14_42_37,
  WhatsApp_Image_2025_04_25_at_14_42_38,
  WhatsApp_Image_2025_04_25_at_14_42_39,
  WhatsApp_Image_2025_04_25_at_14_42_40_1,
  WhatsApp_Image_2025_04_25_at_14_42_40,
  WhatsApp_Image_2025_04_25_at_14_42_41,
  WhatsApp_Image_2025_04_25_at_14_42_42_1,
  WhatsApp_Image_2025_04_25_at_14_42_42,
  WhatsApp_Image_2025_04_25_at_14_42_43,
];

const videos = [
  Colab2,
  Colab,
  KYC2,
  KYC3,
  KYC4,
  KYC5,
  KYC6,
  KYC7,
  KYC8,
];

const Gallery = () => {
  const [activeTab, setActiveTab] = useState('pictures');

  return (
    <section className="gallery">
      <h2>Gallery</h2>
      <div className="gallery-nav">
        <button
          className={activeTab === 'pictures' ? 'active' : ''}
          onClick={() => setActiveTab('pictures')}
        >
          Pictures
        </button>
        <button
          className={activeTab === 'videos' ? 'active' : ''}
          onClick={() => setActiveTab('videos')}
        >
          Videos
        </button>
      </div>
      {activeTab === 'pictures' && (
        <div className="gallery-grid">
          {images.map((img, index) => (
            <div key={index} className="gallery-item">
              <img src={img} alt={`Gallery pic ${index + 1}`} className="gallery-image" />
            </div>
          ))}
        </div>
      )}
      {activeTab === 'videos' && (
        <div className="gallery-grid">
          {videos.map((video, index) => (
            <div key={index} className="gallery-item">
              <video
                src={video}
                controls
                className="gallery-video"
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default Gallery;
